/**
 * A `blob:` URL for something staged but not yet uploaded, made once and taken
 * back when it is dropped.
 *
 * `URL.createObjectURL` pins its blob in memory until the matching revoke, and
 * a staged receipt is a full-size image: a few pages picked, changed of mind
 * about and picked again is tens of megabytes the tab goes on holding. So the
 * URL is kept on the prepared receipt it belongs to — in a `WeakMap`, so a
 * page dropped without anybody thinking to revoke it takes its entry with it —
 * and every screen that shows a staged thumbnail uses these two functions
 * rather than calling the URL API itself.
 */

const urls = new WeakMap<object, string>()

export function previewUrl(owner: object, blob: Blob): string {
  const existing = urls.get(owner)
  if (existing) return existing
  const url = URL.createObjectURL(blob)
  urls.set(owner, url)
  return url
}

export function releasePreview(owner: object): void {
  const url = urls.get(owner)
  if (url === undefined) return
  URL.revokeObjectURL(url)
  urls.delete(owner)
}
